import { Form, Input } from 'antd';
import { CurrencyInput } from 'components/inputs';
import { INPUT } from 'constants';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { normalizarTexto, parseCurrencyToDB } from 'utils';

export const EditableContext = React.createContext(null);

export const EditableRow = ({ index, ...props }) => {
  const [formB] = Form.useForm();
  return (
    <Form form={props.form ? props.form : formB} component={false}>
      <EditableContext.Provider value={props.form ? props.form : formB}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  inputType,
  inputWidth = '100%',
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);

  useEffect(() => {
    if (editing && inputRef.current) {
      const input = inputRef.current.input || inputRef.current;
      input.focus();

      if (typeof input.select === 'function') {
        setTimeout(() => input.select(), 0);
      }
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing)
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  }

  const save = (e) => {
    const newValue = parseCurrencyToDB(e.target.value);
    if (newValue !== record[dataIndex]) handleSave(record, [dataIndex], newValue);
    toggleEdit();
  }

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      setEditing(false);
      return;
    }

    if (e.key === "Tab") {
      e.preventDefault();

      const editableCells = Array.from(
        document.querySelectorAll('[data-editable-cell="true"]')
      );

      const currentIndex = editableCells.findIndex(
        (cell) => cell === e.target
      );

      let nextIndex;
      if (e.shiftKey) {
        nextIndex = currentIndex === 0 ? editableCells.length - 1 : currentIndex - 1;
      } else {
        nextIndex = currentIndex === editableCells.length - 1 ? 0 : currentIndex + 1;
      }

      editableCells[nextIndex]?.focus();
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        name={dataIndex}
        rules={[{ required: true, message: '' }]}
        style={{
          margin: 0,
          width: inputWidth,
        }}
      >
        {inputType === INPUT.TEXT ? (
          <Input
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onInput={normalizarTexto}
            style={{ width: inputWidth }}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            data-editable-cell="true"
          />
        ) : (
          <CurrencyInput
            ref={inputRef}
            prefix=""
            onPressEnter={save}
            onBlur={save}
            style={{ width: inputWidth }}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            data-editable-cell="true"
          />
        )}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          margin: 0,
          padding: 0,
          width: inputWidth,
        }}
        onClick={toggleEdit}
        tabIndex={0}
        onFocus={toggleEdit}
        data-editable-cell="true"
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
